function checkOnGoogTransPage(): boolean {
  const url = 'edithaustin-com.translate.goog'
  // const url = 'localhost' //for testing

  const onPage = window.location.href.includes(url)
  return !onPage
}

export default checkOnGoogTransPage
